import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { catchError, map, of } from 'rxjs'
import { Backend } from 'src/app/shared/enums/enums'
import { DdcLoggerService } from '../log/ddc-logger.service'

@Injectable({
  providedIn: 'root',
})
export class CategoryService {
  constructor(
    private http: HttpClient,
    private logger: DdcLoggerService,
  ) {}

  get_cats(): any {
    this.logger.info('CATEGORY | get_cats')
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    return this.http.get(`${Backend.HOST_CONTAINER + Backend.CATEGORY}`, httpOptions).pipe(
      map((res: any) => {
        return res.results
      }),
      catchError((error: any) => {
        const errorMessage = error.error
        this.logger.error('CATEGORY | get_cats | catchError | errorMessage: ' + errorMessage)
        return of(errorMessage)
      }),
    )
  }

  get_cats_page(page: number, pageSize: number): any {
    this.logger.info('CATEGORY | get_cats_page | page: ' + page + ' | pageSize: ' + pageSize)
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    return this.http
      .get(
        `${Backend.HOST_CONTAINER + Backend.CATEGORY}?page=${page}&pageSize=${pageSize}`,
        httpOptions,
      )
      .pipe(
        map((res: any) => {
          return res
        }),
        catchError((error: any) => {
          const errorMessage = error.error
          this.logger.error('CATEGORY | get_cats_page | catchError | errorMessage: ' + errorMessage)
          return of(errorMessage)
        }),
      )
  }

  add_cat(cat: any): any {
    this.logger.info('CATEGORY | add_cat | cat: ' + cat)
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    const userData = {
      label: cat,
    }

    return this.http
      .post(`${Backend.HOST_CONTAINER + Backend.CATEGORY}`, userData, httpOptions)
      .pipe(
        map((res: any) => {
          return { success: true, res: res }
        }),
        catchError((error: any) => {
          const errorMessage = error.error
          this.logger.error('CATEGORY | add_cat | catchError | errorMessage: ' + errorMessage)
          return of({ success: false, res: errorMessage })
        }),
      )
  }

  edit_cat(cat_data: any): any {
    this.logger.info('CATEGORY | edit_cat | cat_data: ' + cat_data)
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    const userData = {
      label: cat_data.label,
    }

    return this.http
      .patch(
        `${Backend.HOST_CONTAINER + Backend.CATEGORY + cat_data.id + '/'}`,
        userData,
        httpOptions,
      )
      .pipe(
        map((res: any) => {
          return { success: true, res: res }
        }),
        catchError((error: any) => {
          const errorMessage = error.error
          this.logger.error('CATEGORY | edit_cat | catchError | errorMessage: ' + errorMessage)
          return of({ success: false, res: errorMessage })
        }),
      )
  }

  get_searched_cats(target: string): any {
    this.logger.info('CATEGORY | get_searched_cats | target: ' + target)
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    return this.http
      .get(`${Backend.HOST_CONTAINER + Backend.CATEGORY}search/?label=${target}`, httpOptions)
      .pipe(
        map((res: any) => {
          return res
        }),
        catchError((error: any) => {
          const errorMessage = error.error
          this.logger.error(
            'CATEGORY | get_searched_cats | catchError | errorMessage: ' + errorMessage,
          )
          return of(errorMessage)
        }),
      )
  }

  get_pub_searched_cats(target: string): any {
    this.logger.info('CATEGORY | get_pub_searched_cats | target: ' + target)
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    return this.http
      .get(
        `${Backend.HOST_CONTAINER + Backend.CATEGORY}search/?all=true&label=${target}`,
        httpOptions,
      )
      .pipe(
        map((res: any) => {
          return res
        }),
        catchError((error: any) => {
          const errorMessage = error.error
          this.logger.error(
            'CATEGORY | get_pub_searched_cats | catchError | errorMessage: ' + errorMessage,
          )
          return of(errorMessage)
        }),
      )
  }

  delete_cat(cat_id: number): any {
    this.logger.info('CATEGORY | delete_cat | cat_id: ' + cat_id)
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    return this.http
      .delete(`${Backend.HOST_CONTAINER + Backend.CATEGORY + cat_id + '/'}`, httpOptions)
      .pipe(
        map((res: any) => {
          return { success: true, res: res }
        }),
        catchError((error: any) => {
          const errorMessage = error.error
          this.logger.error('CATEGORY | delete_cat | catchError | errorMessage: ' + errorMessage)
          return of({ success: false, res: errorMessage })
        }),
      )
  }
}
